import {Box, Typography} from '@mui/material';

type ErrorPageProps = {
  imageSrc?: string;
  imageAlt?: string;
  logo?: React.ReactNode;
  title?: string;
  message?: string;
  referenceId?: string;
  action?: React.ReactNode;
  children?: React.ReactNode;
};

export const ErrorPage = ({
  imageSrc,
  imageAlt,
  logo,
  title = 'Oops! Something went wrong',
  message = 'Please try again in a moment.',
  referenceId,
  action,
  children,
}: ErrorPageProps) => {
  return (
    <Box sx={{minHeight: 500}}>
      {imageSrc && (
        <Box
          component="img"
          src={imageSrc}
          alt={imageAlt}
          sx={{
            width: '100%',
            height: 200,
            objectFit: 'cover',
            objectPosition: '50% 30%',
          }}
        />
      )}
      {logo && (
        <Box display="flex" justifyContent="center" sx={{mt: '-45px'}}>
          {logo}
        </Box>
      )}
      <Box
        sx={{
          px: 3,
          py: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography variant="h1" mt={2}>
          {title}
        </Typography>
        <Typography textAlign="center">{message}</Typography>
        {referenceId && (
          <Typography variant="subtitle1">{referenceId}</Typography>
        )}
        {action}
        {children}
      </Box>
    </Box>
  );
};
